import React, { useEffect, useState, useRef } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import Loading from "../helpers/loading_component.js";
import "../styles/payments.css";
import { secretKey } from "../.././data";
import emailjs from "@emailjs/browser";
import { faUpload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const MySwal = withReactContent(Swal2);

const AddClientSellDocuments = (props) => {
  const [client, setClient] = useState([]);
  const [loading, setLoading] = useState(false);
  const [uploadFiles, setUploadFiles] = useState("");
  const [uploadFilesArray, setUploadFilesArray] = useState([]);
  const [uploadFilesNamesArray, setUploadFilesNamesArray] = useState([]);
  const [uploadFilesNamesArrayChanged, setUploadFilesNamesArrayChanged] =
    useState([]);
  const [inputs, setInputs] = useState({});
  const [fileType, setFileType] = useState("sell");
  const [mode, setMode] = useState("loged");
  const [lawMail, setLawMail] = useState("");
  const [password, setPassword] = useState("");

  const fetchClients = async () => {
    var body = {
      leadId: +props.clientId,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getLeadsId", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setClient(data[0]);
        fetchLawMail(data[0].owner);
      })
      .catch((error) => {});
  };

  const fetchLawMail = async (initial) => {
    var body = {
      initial: initial,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getLawMail", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setLawMail(data[0].mail);
        if (initial.includes("Konsultant") || !initial) {
          setLawMail("m.pludowski@kppp.pl");
        }
        setLoading(false);
      })
      .catch((error) => {
        setLawMail("m.pludowski@kppp.pl");
        setLoading(false);
      });
  };

  const getData = async () => {
    setLoading(true);
    fetchClients();
  };

  useEffect(() => {
    getData();
  }, []);

  const changeFiles = (e) => {
    setUploadFiles([]);
    setUploadFilesArray([]);
    setUploadFilesNamesArray([]);

    var check = false;

    Array.from(e.target.files).map((file) => {
      if (file.size > 41943040) {
        MySwal.fire({
          icon: "error",
          title: "Błąd",
          text: "plik przekracza 40MB",
        });
        check = true;
      }
    });

    if (check) {
      return;
    }

    setUploadFiles(e.target.files);
    setUploadFilesArray(Array.from(e.target.files));
    var arr = [];
    Array.from(e.target.files).map((el, index) => {
      arr.push({ id: index, name: el.name });
    });
    setUploadFilesNamesArray(arr);
  };

  const changeFileName = (e) => {
    if (inputs[e.target.value] === "" || inputs[e.target.value] === undefined) {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Wypełnij wymagane pola formularza",
      });
    } else {
      var name = inputs[e.target.value];
      var newFile = new File(
        [uploadFilesArray[e.target.value]],
        name + "." + uploadFilesArray[e.target.value].name.split(".")[1],
        {
          type: uploadFilesArray[e.target.value].type,
        }
      );

      var arr = uploadFilesArray.filter(
        (el, index) => index !== +e.target.value
      );
      arr.push(newFile);

      setUploadFilesArray(arr);
      inputs[e.target.value] = "";
    }
  };

  const deleteTempFile = (e) => {
    var arr = uploadFilesArray.filter((el, index) => index !== +e.target.value);

    setUploadFilesArray(arr);
  };

  const sendFiles = async (e) => {
    var length = uploadFilesArray.length;
    var progr = 0;
    uploadFilesArray.map(async (file) => {
      let formData = new FormData();
      formData.append("file", file);
      formData.append("type", "sell");
      formData.append("leadId", client.id);
      formData.append("user", "Klient - upload dokumentów");

      await fetch("https://apidevkppp.ftpeople.pl/uploadSellFile", {
        method: "POST",
        body: formData,
      })
        .then((response) => {
          return response.text();
        })
        .then(async (responseJson) => {
          ++progr;

          MySwal.fire({
            icon: "success",
            title: "Wysłano plik: " + progr + "/" + length,
            text: "",
          }).then(async (result) => {
            if (progr === length) {
              MySwal.fire({
                icon: "success",
                title:
                  "Twoje dokumenty zostały bezpieczne przekazane do kancelarii. Skontaktujemy się po dokonaniu ich analizy.",
                text: "Zespół Kancelarii Radcy Prawnego Mateusza Płudowskiego",
              }).then(async (result) => {
                if (
                  (!client.owner || client.owner.includes("Konsultant")) &&
                  (client.status === "pierwsza próba uzyskania umowy" ||
                    client.status === "ponowna próba uzyskania umowy")
                ) {
                  var bodyA = {
                    id: client.id,
                  };

                  var url =
                    "https://apidevkppp.ftpeople.pl/setUploadSellConsultant";

                  if (client.type === "SKD") {
                    url =
                      "https://apidevkppp.ftpeople.pl/setUploadSellConsultantSKD";
                  }
                  await fetch(url, {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                      Authorization: secretKey,
                    },
                    body: JSON.stringify(bodyA),
                  })
                    .then((response) => response.text())
                    .then((data) => {
                      return;
                    })
                    .catch((error) => {});
                }
                props.logClientAction(
                  "Klient dodał pliki do sprawy",
                  client.id
                );

                if (client.type !== "SKD") {
                  var bodyA = {
                    lawMail: lawMail,
                    clientId: client.id,
                  };

                  var url = "https://apidevkppp.ftpeople.pl/sendNewDocs";

                  await fetch(url, {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                      Authorization: secretKey,
                    },
                    body: JSON.stringify(bodyA),
                  })
                    .then((response) => response.text())
                    .then((data) => {
                      window.location.replace("https://kppp.pl");
                    })
                    .catch((error) => {});
                }
              });
            }
          });
        });
    });
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const handleLogin = (e) => {
    setLoading(true);
    if (password === client.phone) {
      setMode("loged");
      setLoading(false);
    } else {
      MySwal.fire({
        icon: "error",
        title: "Nieprawidłowe",
        text: "hasło",
      }).then(async (result) => {
        setLoading(false);
      });
    }
  };

  const desk = (
    <>
      <div
        style={{
          display: "flex",
          minHeight: "100vh",
        }}
      >
        <div style={{ width: "60%" }}>
          <div
            className="logoBoxLogin"
            style={{ backgroundColor: "transparent" }}
          >
            <img
              src="https://ftpeople.pl/wp-content/uploads/2023/06/logomain.png"
              alt=""
              style={{
                width: "20vw",
                marginTop: "5vh",
                marginLeft: "2vw",
              }}
            />
          </div>
          <div
            style={{
              textAlign: "left",
              fontSize: "2vw",
              marginBottom: "5vh",
              marginTop: "2vh",
              color: "#898989",
              fontWeight: "900",
              paddingLeft: "2vw",
            }}
          >
            Unieważnimy Twoją umowę frankową z bankiem
          </div>
          <img
            src="https://apidevkppp.ftpeople.pl/bg_sell.jpg"
            alt=""
            style={{
              width: "70vw",
            }}
          />
          <div
            style={{
              display: "flex",
              gap: "20px",
              paddingLeft: "2vw",
              padding: "2vh 2vw",
              justifyContent: "left",
            }}
          >
            <a
              style={{
                backgroundColor: "rgb(0, 189, 206)",
                padding: "10px 20px",
                borderRadius: "20px",
                fontWeight: "600",
                textDecoration: "none",
                color: "white",
                width: "50%",
                textAlign: "center",
              }}
              href="https://www.google.com/search?sa=X&sca_esv=601222021&rlz=1C5CHFA_enPL948PL948&tbm=lcl&sxsrf=ACQVn0_s6eJiC82WzsOHZvymItYbpiV-Wg:1706138595307&q=Kancelaria+Radcy+Prawnego+Mateusz+P%C5%82udowski+Opinie&rflfq=1&num=20&stick=H4sIAAAAAAAAAONgkxIxNDC1NDI0MzEyM7I0NrKwNLIwN9_AyPiK0dg7MS85NSexKDNRISgxJblSIaAosTwvNT1fwTexJLW0uEoh4GhTaUp-eXF2poJ_QWZeZuoiVnJ0AQAEmfg6hwAAAA&rldimm=10592164262932892877&hl=pl-PL&ved=2ahUKEwi_rKTHlfeDAxWyLBAIHSxoD0sQ9fQKegQIFRAF&biw=1512&bih=857&dpr=2#lkt=LocalPoiReviews"
              target="_blank"
            >
              Google <span style={{ color: "yellow" }}>★★★★★</span> 5.0/43
              opinie
            </a>
            <a
              style={{
                backgroundColor: "rgb(0, 189, 206)",
                padding: "10px 20px",
                borderRadius: "20px",
                fontWeight: "600",
                textDecoration: "none",
                color: "white",
                width: "50%",
                textAlign: "center",
                display: "flex",
                alignItems: "center",
                gap: "5px",
                justifyContent: "center",
              }}
              href="https://www.youtube.com/@kancelariaradcyprawnegomat109/videos"
              target="_blank"
            >
              <img
                src="https://apidevkppp.ftpeople.pl/yt_sell.png"
                alt=""
                style={{
                  width: "5%",
                }}
              />
              Sprawdź nasz kanał YouTube
            </a>
          </div>

          <div
            style={{
              display: "flex",
              gap: "20px",
              paddingLeft: "2vw",
              padding: "1vh 2vw",
              justifyContent: "center",
            }}
          >
            <a
              style={{
                border: "2px solid rgb(0, 189, 206)",
                padding: "10px 20px",
                borderRadius: "20px",
                fontWeight: "600",
                textDecoration: "none",
                color: "black",
                width: "70%",
                textAlign: "center",
                textTransform: "uppercase",
                fontSize: "1.5vw",
              }}
              href="https://kppp.pl/polityka-prywatnosci/"
              target="_blank"
            >
              🔒 Twoje dane są u nas bezpieczne
            </a>
          </div>
        </div>
        <div
          style={{
            width: "40%",
            backgroundColor: "lightgray",
            paddingTop: "10vh",
            overflow: "scroll",
            marginRight: "5vw",
          }}
        >
          <div style={{ padding: "2vh 2vw" }}>
            <div
              style={{
                textAlign: "center",
                fontSize: "2vw",
                marginBottom: "2vh",
                color: "white",
                fontWeight: "900",
                textTransform: "uppercase",
              }}
            >
              <span style={{ color: "rgb(0, 189, 206)" }}>{client.name}</span>{" "}
              PRZEŚLIJ BEZPIECZNIE SKANY LUB ZDJĘCIA SWOJEJ UMOWY KREDYTOWEJ
            </div>
            <div
              style={{
                textAlign: "center",
                fontSize: "1vw",
                marginBottom: "10vh",
                color: "gray",
                padding: "1vw 2vw",
              }}
            >
              Będziemy analizować wyłącznie parametry kredytu, dlatego możesz
              zakryć swoje dane osobowe.
              <br /> <br /> W przypadku problemów technicznych prosimy o kontakt
              pod numerem 608 64 91 07 lub na adres e-mail: kancelaria@kppp.pl.
            </div>
            <>
              <div
                style={{
                  width: "100%",
                  textAlign: "center",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <div
                  style={{
                    width: "30vw",
                    height: "20vh",
                    border: "3px dashed rgb(0, 189, 206)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexWrap: "wrap",
                    position: "relative",
                  }}
                >
                  <div
                    for="file"
                    style={{
                      width: "100%",
                      textAlign: "center",
                      paddingTop: "2vh",
                    }}
                  >
                    <p
                      style={{
                        textTransform: "uppercase",
                        fontSize: "1vw",
                        color: "white",
                      }}
                    >
                      Przeciągnij plik tutaj lub kliknij aby wyszukać
                    </p>
                    <p
                      style={{
                        color: "rgb(0, 189, 206)",
                        fontSize: "3vw",
                      }}
                    >
                      <FontAwesomeIcon icon={faUpload} />
                    </p>
                  </div>
                  <div
                    style={{
                      width: "100%",
                      height: "100%",
                      marginTop: "-20vh",
                    }}
                  >
                    <input
                      multiple={true}
                      type="file"
                      onChange={changeFiles}
                      if="file"
                      style={{
                        textAlign: "center",
                        cursor: "pointer",
                        width: "100%",
                        height: "100%",
                        opacity: "0",
                        zIndex: "2",
                        position: "absolute",
                        top: "0",
                        left: "0",
                        margin: "0",
                      }}
                    />
                  </div>
                </div>
              </div>
              <>
                <div
                  style={{ marginTop: "0", marginBottom: "5vh" }}
                  className="inputBox"
                ></div>
              </>
              <>
                {uploadFilesArray.length > 0 ? (
                  <>
                    <div
                      style={{
                        width: "100%",
                        maxHeight: "35vh",
                        overflowY: "scroll",
                      }}
                    >
                      <table
                        style={{
                          width: "100%",
                          boxSizing: "border-box",
                        }}
                        id="detailClientTable"
                        className="clients_table"
                      >
                        <tr>
                          <th>Nazwa pliku</th>
                          <th>Plik</th>
                          <th></th>
                        </tr>
                        {uploadFilesArray.length > 0
                          ? uploadFilesArray.map((el, index) => (
                              <>
                                <tr>
                                  <td
                                    style={{
                                      width: "50%",
                                      padding: "5px 20px",
                                      height: "3vh",
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        gap: "10px",
                                      }}
                                    >
                                      <input
                                        id={"fn" + index}
                                        name={"fn" + index}
                                        style={{
                                          height: "2vh",
                                          marginTop: "0",
                                        }}
                                        type="text"
                                        value={inputs[index]}
                                        onChange={(e) =>
                                          setInputs((prev) => {
                                            return {
                                              ...prev,
                                              [index]: e.target.value,
                                            };
                                          })
                                        }
                                      />
                                      <button
                                        className="refreshButton"
                                        value={index}
                                        onClick={changeFileName}
                                      >
                                        zmień
                                      </button>
                                    </div>
                                  </td>
                                  <td
                                    style={{
                                      textAlign: "left",
                                      width: "40%",
                                      padding: "5px 20px",
                                      height: "3vh",
                                    }}
                                  >
                                    {el.name}
                                  </td>
                                  <td
                                    style={{
                                      textAlign: "left",
                                      width: "10%",
                                      padding: "5px 20px",
                                      height: "3vh",
                                    }}
                                  >
                                    <button
                                      className="refreshButton"
                                      value={index}
                                      onClick={deleteTempFile}
                                    >
                                      usuń
                                    </button>
                                  </td>
                                </tr>
                              </>
                            ))
                          : ""}
                      </table>
                    </div>
                    <div style={{ marginTop: "2vh" }}>
                      <button
                        style={{ width: "15%" }}
                        className="refreshButton"
                        onClick={sendFiles}
                      >
                        Wyślij
                      </button>
                    </div>
                  </>
                ) : (
                  ""
                )}
              </>
            </>
          </div>
        </div>
      </div>
    </>
  );

  const mobile = (
    <>
      <div
        style={{
          display: "flex",
          minHeight: "100vh",
          flexWrap: "wrap",
        }}
      >
        <div style={{ width: "100%" }}>
          <div
            className="logoBoxLogin"
            style={{ backgroundColor: "transparent" }}
          >
            <img
              src="https://ftpeople.pl/wp-content/uploads/2023/06/logomain.png"
              alt=""
              style={{
                width: "30vw",
                marginTop: "5vh",
                marginLeft: "2vw",
              }}
            />
          </div>
          <div
            style={{
              textAlign: "left",
              fontSize: "4vw",
              marginBottom: "5vh",
              marginTop: "2vh",
              color: "#898989",
              fontWeight: "900",
              paddingLeft: "2vw",
            }}
          >
            Unieważnimy Twoją umowę frankową z bankiem
          </div>
          <img
            src="https://apidevkppp.ftpeople.pl/bg_sell.jpg"
            alt=""
            style={{
              width: "100vw",
            }}
          />
          <div
            style={{
              display: "flex",
              gap: "20px",
              paddingLeft: "2vw",
              padding: "2vh 2vw",
              justifyContent: "left",
            }}
          >
            <a
              style={{
                backgroundColor: "rgb(0, 189, 206)",
                padding: "10px 20px",
                borderRadius: "20px",
                fontWeight: "600",
                textDecoration: "none",
                color: "white",
                width: "50%",
                textAlign: "center",
                fontSize: "2vw",
              }}
              href="https://www.google.com/search?sa=X&sca_esv=601222021&rlz=1C5CHFA_enPL948PL948&tbm=lcl&sxsrf=ACQVn0_s6eJiC82WzsOHZvymItYbpiV-Wg:1706138595307&q=Kancelaria+Radcy+Prawnego+Mateusz+P%C5%82udowski+Opinie&rflfq=1&num=20&stick=H4sIAAAAAAAAAONgkxIxNDC1NDI0MzEyM7I0NrKwNLIwN9_AyPiK0dg7MS85NSexKDNRISgxJblSIaAosTwvNT1fwTexJLW0uEoh4GhTaUp-eXF2poJ_QWZeZuoiVnJ0AQAEmfg6hwAAAA&rldimm=10592164262932892877&hl=pl-PL&ved=2ahUKEwi_rKTHlfeDAxWyLBAIHSxoD0sQ9fQKegQIFRAF&biw=1512&bih=857&dpr=2#lkt=LocalPoiReviews"
              target="_blank"
            >
              Google <span style={{ color: "yellow" }}>★★★★★</span> 5.0/43
              opinie
            </a>
            <a
              style={{
                backgroundColor: "rgb(0, 189, 206)",
                padding: "10px 20px",
                borderRadius: "20px",
                fontWeight: "600",
                textDecoration: "none",
                color: "white",
                width: "50%",
                textAlign: "center",
                display: "flex",
                alignItems: "center",
                gap: "5px",
                justifyContent: "center",
                fontSize: "2vw",
              }}
              href="https://www.youtube.com/@kancelariaradcyprawnegomat109/videos"
              target="_blank"
            >
              <img
                src="https://apidevkppp.ftpeople.pl/yt_sell.png"
                alt=""
                style={{
                  width: "7%",
                }}
              />
              Sprawdź nasz kanał YouTube
            </a>
          </div>

          <div
            style={{
              display: "flex",
              gap: "20px",
              paddingLeft: "2vw",
              padding: "0vh 2vw",
              justifyContent: "center",
            }}
          >
            <a
              style={{
                border: "2px solid rgb(0, 189, 206)",
                padding: "5px 10px",
                borderRadius: "20px",
                fontWeight: "600",
                textDecoration: "none",
                color: "black",
                width: "70%",
                textAlign: "center",
                textTransform: "uppercase",
                fontSize: "2.5vw",
              }}
              href="https://kppp.pl/polityka-prywatnosci/"
              target="_blank"
            >
              🔒 Twoje dane są u nas bezpieczne
            </a>
          </div>
        </div>
        <div
          style={{
            width: "100%",
            backgroundColor: "lightgray",
            overflow: "scroll",
            marginTop: "2vh",
          }}
        >
          <div style={{ padding: "2vh 2vw" }}>
            <div
              style={{
                textAlign: "center",
                fontSize: "4vw",
                marginBottom: "2vh",
                color: "white",
                fontWeight: "900",
                textTransform: "uppercase",
              }}
            >
              <span style={{ color: "rgb(0, 189, 206)" }}>{client.name}</span>{" "}
              PRZEŚLIJ BEZPIECZNIE SKANY LUB ZDJĘCIA SWOJEJ UMOWY KREDYTOWEJ
            </div>
            <div
              style={{
                textAlign: "center",
                fontSize: "3vw",
                marginBottom: "3vh",
                color: "gray",
                padding: "1vw 2vw",
              }}
            >
              Będziemy analizować wyłącznie parametry kredytu, dlatego możesz
              zakryć swoje dane osobowe.
              <br /> <br /> W przypadku problemów technicznych prosimy o kontakt
              pod numerem 608 64 91 07 lub na adres e-mail: kancelaria@kppp.pl.
            </div>
            <>
              <div
                style={{
                  width: "100%",
                  textAlign: "center",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <div
                  style={{
                    width: "80%",
                    height: "20vh",
                    border: "3px dashed rgb(0, 189, 206)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexWrap: "wrap",
                    position: "relative",
                  }}
                >
                  <div
                    for="file"
                    style={{
                      width: "100%",
                      textAlign: "center",
                      paddingTop: "2vh",
                    }}
                  >
                    <p
                      style={{
                        textTransform: "uppercase",
                        fontSize: "3vw",
                        color: "white",
                      }}
                    >
                      Przeciągnij plik tutaj lub kliknij aby wyszukać
                    </p>
                    <p
                      style={{
                        color: "rgb(0, 189, 206)",
                        fontSize: "6vw",
                      }}
                    >
                      <FontAwesomeIcon icon={faUpload} />
                    </p>
                  </div>
                  <div
                    style={{
                      width: "100%",
                      height: "100%",
                      marginTop: "-20vh",
                    }}
                  >
                    <input
                      multiple={true}
                      type="file"
                      onChange={changeFiles}
                      if="file"
                      style={{
                        textAlign: "center",
                        cursor: "pointer",
                        width: "100%",
                        height: "100%",
                        opacity: "0",
                        zIndex: "2",
                        position: "absolute",
                        top: "0",
                        left: "0",
                        margin: "0",
                      }}
                    />
                  </div>
                </div>
              </div>
              <>
                <div
                  style={{ marginTop: "0", marginBottom: "5vh" }}
                  className="inputBox"
                ></div>
              </>
              <>
                {uploadFilesArray.length > 0 ? (
                  <>
                    <div
                      style={{
                        width: "100%",
                        maxHeight: "35vh",
                        overflowY: "scroll",
                      }}
                    >
                      <table
                        style={{
                          width: "100%",
                          boxSizing: "border-box",
                        }}
                        id="detailClientTable"
                        className="clients_table"
                      >
                        <tr>
                          <th>Nazwa pliku</th>
                          <th>Plik</th>
                          <th></th>
                        </tr>
                        {uploadFilesArray.length > 0
                          ? uploadFilesArray.map((el, index) => (
                              <>
                                <tr>
                                  <td
                                    style={{
                                      width: "50%",
                                      padding: "5px 20px",
                                      height: "3vh",
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        gap: "10px",
                                      }}
                                    >
                                      <input
                                        id={"fn" + index}
                                        name={"fn" + index}
                                        style={{
                                          height: "2vh",
                                          marginTop: "0",
                                        }}
                                        type="text"
                                        value={inputs[index]}
                                        onChange={(e) =>
                                          setInputs((prev) => {
                                            return {
                                              ...prev,
                                              [index]: e.target.value,
                                            };
                                          })
                                        }
                                      />
                                      <button
                                        className="refreshButton"
                                        value={index}
                                        onClick={changeFileName}
                                      >
                                        zmień
                                      </button>
                                    </div>
                                  </td>
                                  <td
                                    style={{
                                      textAlign: "left",
                                      width: "40%",
                                      padding: "5px 20px",
                                      height: "3vh",
                                    }}
                                  >
                                    {el.name}
                                  </td>
                                  <td
                                    style={{
                                      textAlign: "left",
                                      width: "10%",
                                      padding: "5px 20px",
                                      height: "3vh",
                                    }}
                                  >
                                    <button
                                      className="refreshButton"
                                      value={index}
                                      onClick={deleteTempFile}
                                    >
                                      usuń
                                    </button>
                                  </td>
                                </tr>
                              </>
                            ))
                          : ""}
                      </table>
                    </div>
                    <div style={{ marginTop: "2vh" }}>
                      <button
                        style={{ width: "15%" }}
                        className="refreshButton"
                        onClick={sendFiles}
                      >
                        Wyślij
                      </button>
                    </div>
                  </>
                ) : (
                  ""
                )}
              </>
            </>
          </div>
        </div>
      </div>
    </>
  );

  return (
    <>
      <div>
        {loading ? (
          <Loading id="popUpLoading" />
        ) : (
          <>
            {mode !== "loged" ? (
              <>
                <div className="mainContainerLoginPage">
                  <div className="logoBoxLogin">
                    <img
                      src="https://ftpeople.pl/wp-content/uploads/2022/12/logomain.png"
                      alt=""
                    />
                  </div>

                  <div className="inputContainerLogin">
                    <div className="inputBoxLogin">
                      <span style={{ fontSize: "2vw", fontWeight: "600" }}>
                        UZUPEŁNIJ PLIKI UMOWY KREDYTOWEJ
                      </span>
                    </div>
                  </div>
                  <div
                    style={{ marginTop: "0" }}
                    className="inputContainerLogin"
                  >
                    <div className="inputBoxLogin">
                      <label id="loginLabel">Hasło</label>
                      <input
                        type="password"
                        id="password"
                        name="password"
                        value={password}
                        onChange={handlePasswordChange}
                      />
                      <button
                        className="loginButtonLogin"
                        value="yes"
                        onClick={handleLogin}
                      >
                        ZALOGUJ
                      </button>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              ""
            )}
            {mode === "loged" ? (
              <>
                <div className="desktopFilters" style={{ padding: "0" }}>
                  {desk}
                </div>
                <div className="mobileFilters" style={{ padding: "0" }}>
                  {mobile}
                </div>
              </>
            ) : (
              ""
            )}
          </>
        )}
      </div>
    </>
  );
};

export default AddClientSellDocuments;
